module.exports = __webpack_public_path__ + "static/img/font-4.9293d93a.svg";